import RaceReviewQuestion from './RaceReviewQuestion';

export default RaceReviewQuestion;
